import React from "react";
import styled from "styled-components";
import { translate } from "../services/i18n";

const RankTable = styled.div`
  table {
    min-width: fit-content;
    width: 100%;
  }

  tr:nth-child(even) {
    background-color: #f1f1f1;
  }
  th {
    background-color: #eaeaea;
  }

  th,
  td {
    text-align: center;
    padding: 10px;
  }

  @media (min-width: 780px) {
    max-height: 70vh;
  }

  .tooltip {
    position: relative;
    cursor: pointer;
  }

  .tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }

  .tooltip-text {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    background-color: black;
    color: white;
    text-align: center;
    padding: 5px;
    border-radius: 4px;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    transition: opacity 0.2s ease-in-out;
  }
`;

const NotFound = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #888888;
  gap: 16px;

  svg {
    width: 48px;
    height: 48px;
    opacity: 0.5;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
`;

const Table = (props) => {
  const { data, searchTerm } = props;

  if (data) {
    try {
      if (data[0]["points"]) {
        for (let i = 0; i < data.length; i++) {
          delete data[i]["type"];
        }
      }

      if (data[0].name) {
        for (let i = 0; i < data.length; i++) {
          delete data[i].points;
          delete data[i].class;
          delete data[i].subClass;
          delete data[i].classLineage;
          delete data[i].subClassLineage;
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
  if (!Array.isArray(data) || !data[0]) return <></>;

  const filtered = searchTerm
    ? data.filter((row) => row.name?.toLowerCase().includes(searchTerm.toLowerCase()))
    : data;

  if (filtered.length === 0) {
    return (
      <NotFound>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
          <line x1="8" y1="11" x2="14" y2="11" />
        </svg>
        <p>{translate("search.notFound", { defaultValue: "Nenhum jogador encontrado" })}</p>
      </NotFound>
    );
  }

  const nicknameCount = filtered.reduce((acc, curr) => {
    acc[curr.name] = (acc[curr.name] || 0) + 1;
    return acc;
  }, {});
  return (
    <RankTable>
      <table>
        <thead>
          <tr>
            <th>Position</th>
            {Object.keys(filtered[0]).map((key) => {
              if (
                key === "position" ||
                key === "guild" ||
                key === "isVIP" ||
                key === "class" ||
                key === "subClass" ||
                key === "classLineage" ||
                key === "subClassLineage"
              ) {
                return;
              }

              if (key === "Soma Level") {
                return <th>Level Total</th>;
              }
              return <th key={key}>{key[0].toUpperCase() + key.slice(1)}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {filtered.map((row) => {
            const originalPos = data.indexOf(row) + 1;
            return (
              <tr key={originalPos}>
                <td>{originalPos}º</td>
                {Object.keys(row).map((value) => {
                  if (
                    value === "position" ||
                    value === "isVIP" ||
                    value === "class" ||
                    value === "subClass" ||
                    value === "classLineage" ||
                    value === "subClassLineage"
                  ) {
                    return;
                  }

                  if (value === "guildMark") {
                    let link =
                      row[value] === "w00000000"
                        ? `https://wydmisc.raidhut.com.br/guild/guild0.gif`
                        : `https://wydmisc.raidhut.com.br/guild/img_guilds/global/${row[value]}.bmp`;
                    return (
                      <td>
                        <img src={link} alt="" />
                      </td>
                    );
                  }

                  if (value === "kingdom") {
                    return (
                      <td>
                        <img
                          src={`https://wydmisc.raidhut.com.br/guild/${row[value]}.gif`}
                          alt=""
                        />
                      </td>
                    );
                  }

                  if (value === "guild") {
                    return;
                  }

                  if (value === "name") {
                    const isDuplicate = nicknameCount[row[value]] > 1;
                    return (
                      <td key={value}>
                        <div className="tooltip">
                          {row[value]}
                          {isDuplicate && (
                            <span className="tooltip-text">
                              Jogador possui mais de um personagem com esse nome
                            </span>
                          )}
                        </div>
                      </td>
                    );
                  }
                  return <td key={value}>{row[value]}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </RankTable>
  );
};

export default Table;
